import { useCompanyPlanContext } from 'FeatureModules/Auth/Contexts/CompanyPlanContext';
import { TCustomerPlanType } from 'FeatureModules/Auth/types/company.types';

const useHasAccess = (allowedPlans: TCustomerPlanType[]) => {
  const { plan } = useCompanyPlanContext();

  return allowedPlans.includes(plan);
};

export default useHasAccess;
